import React from 'react';
import { Input, Label } from 'reactstrap';
import PropTypes from 'prop-types';
import _ from 'lodash';
import withFormsyValidations from '../withFormsyValidations';

class ConfirmInput extends React.Component {
  static get propTypes() {
    return {
      id: PropTypes.string,
      setValue: PropTypes.func.isRequired,
    };
  }

  static get defaultProps() {
    return {
      id: _.uniqueId(),
    };
  }

  constructor(props) {
    super(props);
    this.changeValue = this.changeValue.bind(this);
  }

  changeValue(event) {
    const { setValue } = this.props;
    const { checked } = event.target;
    const value = !!checked;
    setValue(value);
  }

  render() {
    const { id } = this.props;

    return (
      <div>
        <div className="">
          <Input
            id={id}
            type="checkbox"
            data-switch="bool"
            onChange={this.changeValue}
          />
          <Label for={id} data-on-label="Ja" data-off-label="Nej" />
        </div>
      </div>
    );
  }
}

export default withFormsyValidations(ConfirmInput, () => ({
  mustBeTrue(values, value) {
    return value;
  },
}));
